import React from 'react';
import './MiniStatusBar.css'; // Estilos específicos para este componente

const MiniStatusBar = ({ currentStep, totalSteps }) => {
  // Calcula el porcentaje de la barra de progreso
  const progressPercentage = totalSteps > 1 ? ((currentStep - 1) / (totalSteps - 1)) * 100 : 0;
const pasosEspeciales = [4, 7];


  return (
    <div className="mini-status-bar-container">
      {/* Línea de progreso de fondo */}
      <div className="mini-status-line-bg"></div>
      {/* Línea de progreso activa */}
      <div className="mini-status-line-progress" style={{ width: `${progressPercentage}%` }}></div>
      
      <div className="mini-status-nodes">
        {/* Crea un array temporal para renderizar el número correcto de nodos */}
        {Array.from({ length: totalSteps }).map((_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;

          const isSpecial = pasosEspeciales.includes(stepNumber);

          // Asigna clases CSS según el estado de cada nodo
         const nodeClasses = `mini-node-circle 
            ${isCompleted ? 'completed' : ''} 
            ${isActive ? 'active' : ''}
            ${isSpecial ? 'special-step' : ''}
          `;
          
          return <div key={stepNumber} className={nodeClasses}></div>;
        })}
      </div>
    </div>
  );
};

export default MiniStatusBar;